"use strict";

var ConnectionState;

(function (ConnectionState) {
  ConnectionState["Connected"] = "connected";
  ConnectionState["Disconnected"] = "disconnected";
  ConnectionState["Error"] = "error";
  ConnectionState["NotCreated"] = "notCreated";
})(ConnectionState || (ConnectionState = {}));